module.exports = __webpack_public_path__ + "sgby/img/bg4.196a9f3.jpg";